import React from "react";
import {Welcome} from "./layout/WelcomeLayout";
import {BirthdayStep} from "./layout/Birthday"; // Add this import
import {getSplashConfig, stepsConfig} from "../config/steps";
import {HeightInput} from "./layout/Height";
import {SingleSelect} from "./layout/common/SingleSelect";
import {MultiSelect} from "./layout/common/MultiSelect";
import {WeightInput} from "./layout/Weight";
import {WeightGoal} from "./layout/WeightGoal";
import {ImageLayout} from "./layout/common/Image";
import {Summary} from "./layout/Summary";
import {LifestyleAssessment} from "./layout/LifestyleAssessment";
import {RatingScale} from "./layout/common/RatingScale";
import {NutritionReport} from "./layout/NutritionReport";
import {FeaturesPreview} from "./layout/FeaturesPreview";
import {SplashScreenRouter} from "./layout/splash/SplashScreenRouter";
import {WeightPrediction} from "./layout/WeightPrediction";
import {Testimonial} from "./layout/Testimonial";
import {EmailCollection} from "./layout/Email";
import {Paywall} from "./layout/paywall/Paywall";

export function StepRenderer({stepId}) {
    // Handle splash screens
    if (typeof stepId === "string" && stepId.startsWith("splash_")) {
        const originalStep = parseInt(stepId.split("_")[1]);
        const splashConfig = getSplashConfig(originalStep); // Get config using the utility function

        if (!splashConfig) {
            console.warn(`No splash screen config found for step ${originalStep}`);
            return null;
        }

        return <SplashScreenRouter config={splashConfig}/>;
    }

    const stepConfig = stepsConfig.steps[stepId];

    switch (stepConfig.layout) {
        case "welcome":
            return <Welcome config={stepConfig}/>;

        case "single_select":
            return <SingleSelect config={stepConfig}/>;

        case "multi_select":
            return <MultiSelect config={stepConfig}/>;

        case "birthday": // Add this case
            return <BirthdayStep config={stepConfig}/>;

        case "height":
            return <HeightInput config={stepConfig}/>;

        case "weight":
            return <WeightInput config={stepConfig}/>;

        case "weight_goal":
            return <WeightGoal config={stepConfig}/>;

        case "image":
            return <ImageLayout config={stepConfig}/>;

        case "summary":
            return <Summary config={stepConfig}/>;

        case "lifestyle_assessment":
            return <LifestyleAssessment config={stepConfig}/>;

        case "rating_scale":
            return <RatingScale config={stepConfig}/>;

        case "nutrition_report":
            return <NutritionReport config={stepConfig}/>;

        case "features_preview":
            return <FeaturesPreview config={stepConfig}/>;

        case "weight_prediction":
            return <WeightPrediction config={stepConfig}/>;

        case "testimonial":
            return <Testimonial config={stepConfig}/>;

        case "email_collection":
            return <EmailCollection config={stepConfig}/>;

        case "paywall":
            return <Paywall config={stepConfig}/>;

        default:
            return null;
    }
}
